/**
 * Устойчивый ключ трека общей библиотеки примеров — имя файла без расширения
 * («tyoplyy-vinil»). В отличие от индекса не съезжает при перестановке TRACKS.
 */
export const trackKey = (t) => t.song.replace(/\.[^.]+$/, "");
